import { createContext, useContext, useMemo, useState } from 'react'

// Sections of the My Account area. Navigation between them is driven by the
// account sidebar (components/doctorProfile/Sidebar) rather than an in-page tab
// bar, so the selected section is shared via this context between the sidebar
// and the content area (which are siblings rendered under AccountPage).
export const ACCOUNT_SECTIONS = {
  PROFILE: 'profile',
  WALLET: 'wallet',
  SETTINGS: 'settings',
  SECURITY: 'security',
}

const AccountSectionContext = createContext(null)

export const AccountSectionProvider = ({ children }) => {
  const [section, setSection] = useState(ACCOUNT_SECTIONS.PROFILE)
  const value = useMemo(() => ({ section, setSection }), [section])
  return (
    <AccountSectionContext.Provider value={value}>{children}</AccountSectionContext.Provider>
  )
}

// Safe to call outside a provider: falls back to the Profile section with a
// no-op setter so the sidebar component can be reused elsewhere without crashing.
export const useAccountSection = () => {
  const ctx = useContext(AccountSectionContext)
  if (!ctx) {
    return { section: ACCOUNT_SECTIONS.PROFILE, setSection: () => {} }
  }
  return ctx
}
